import { render } from "./EventCard.vue?vue&type=template&id=5665269c&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=5665269c&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue practice\\vue mastery\\real world vue 3\\7. Deploying with Render\\deploying-with-render\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5665269c"]])

export default __exports__